<template>
  <div>
     <!-- 初次登录修改密码 -->
     <div>
      <el-dialog width="60%" :visible.sync="Passwordmodification" :show-close="false" :close-on-click-modal="false" class="dialogmimaxg" :modal-append-to-body="false" :append-to-body="true">
        <div v-if="judgeWeb">
             <el-steps :active="active" space="100px">
                <!-- <el-step title=""></el-step> -->
                <el-step title=""></el-step>
                <el-step title=""></el-step>
              </el-steps>
          </div>
          <!-- <div v-if="active==1">
            <div class="toutxt">
              {{$t('dashboardCont.setPassword')}}
            </div>
            <div class="toutxt1">{{$t('dashboardCont.weclomeLogin')}}</div>
            <div>
              <el-form :model="ruleForm" status-icon :rules="rulest" label-position="top" ref="ruleForm" label-width="100px" class="demo-ruleFormty">
                <el-form-item :label="$t('dashboardCont.originalPassword')" prop="oldPassword">
                  <el-input size="medium" type="password"   v-model="ruleForm.oldPassword" autocomplete="off" :placeholder="$t('dashboardCont.originalPasswordEnter')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('dashboardCont.loginPassword')" prop="pass">
                  <el-input size="medium" type="password" v-model="ruleForm.pass" autocomplete="off" :placeholder="$t('dashboardCont.loginPasswordRequirement')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('dashboardCont.duplicatePassword')" prop="checkPass">
                  <el-input size="medium" type="password" v-model="ruleForm.checkPass" autocomplete="off" 
                 :placeholder="$t('dashboardCont.passwordSure')"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="buttontmat('ruleForm')" class="buttont">{{$t('dashboardCont.next')}}</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div> -->
           <div v-if="active==2">
            <div class="toutxt">
              {{$i18.language('AI智能推荐设置')}}
            </div>
            <div class="toutxt1">{{$i18.language('完成AI智能推荐设置，系统将在每周一推荐采购商，可通过总览中的「AI智能推荐」查看。')}}</div>
            <!-- <div class="toutxt1">{{$t('dashboardCont.selfTargetResult')}}</div> -->
            <div>
              <el-form :model="ruleForm2" :rules="rulest2" label-position="top" ref="ruleForm2" label-width="100px" class="demo-ruleFormty">
                <div class="open-ai-switch">
                  <p style="font-weight: 600">{{$i18.language('开启智能推荐')}}</p>
                  <el-switch v-model="ruleForm2.opened" :active-text="ruleForm2.opened ? this.$i18.language('已开启') : this.$i18.language('已关闭') ">
                  </el-switch>
                </div>
                <span v-show="!ruleForm2.opened" class="LaterTips">{{ $i18.language("您可以稍后在「总览」的「AI智能推荐」中开启推荐") }}</span>
                <productAndHs style="margin-bottom: 10px;" :disabled="!ruleForm2.opened" ref="productAndHs" :form="ruleForm2" :defaultHsForm="defaultHsForm" @hscodeSearch="(item)=>showHsCodeSelect(0, item)">

                </productAndHs>
              <!-- 所属行业: -->
              <el-form-item :label="$i18.language('所属行业：')" :class="[!ruleForm2.opened?'is-disabled':'','form-item','remove-icon', 'multiple-box']" prop="belonging_to_industrys">
                <span :class="!ruleForm2.opened?'is-disabled ai_generate':'ai_generate'" @click="aiGenerate('industry')">{{ $i18.language('AI生成') }}</span>
                <customSelect v-show="!industry_loading" :placeholder="$i18.language('请选择')" keyValue="val"
                  style="width: 100%" :data="contactHsCodes" :class="!ruleForm2.opened?'is-disabled':''"
                  @clickSelect="showIndustrySelect" @removeTag="handleRemove">
                </customSelect>
                <el-skeleton v-show="industry_loading" animated :rows="1"></el-skeleton>
                <!-- 推荐原因 -->
                <div class="reason" v-show="aiGenerateData.showIndustryReason">
                  <svg-icon class="reason-why-icon" name="reason-why"></svg-icon>
                  <span class="content">{{$i18.language('推荐原因：按照您输入的商品的关键词的行业上下游关系，AI智能推荐了的相关行业')}}</span>
                </div>             
              </el-form-item>
              <!-- 感兴趣的国家 -->
                <el-form-item :class="[!ruleForm2.opened?'is-disabled':'','form-item','remove-icon', 'elselect']" :label="$t('dashboardCont.interestedCountry')"> 
                  <span :class="!ruleForm2.opened?'is-disabled ai_generate':'ai_generate'" :disabled="!ruleForm2.opened" @click="aiGenerate('country')">{{ $i18.language('AI生成') }}</span>
                  <customSelect v-show="!country_loading" :placeholder="$i18.language('请可以选择多个感兴趣的国家/地区')" keyValue="value"
                    style="width: 100%" :data="ruleForm2.country" :class="!ruleForm2.opened?'is-disabled':''"
                    @clickSelect="xunxioanggj" @removeTag="handleRemoveCountry">
                  </customSelect>
                  <el-skeleton v-show="country_loading" animated :rows="1"></el-skeleton>
                  <!-- 推荐原因 -->
                  <div class="reason" v-show="aiGenerateData.showCountryReason">
                    <svg-icon class="reason-why-icon" name="reason-why"></svg-icon>
                    <span v-html="$i18.language('推荐原因：上述国家/地区，近一年的相关品类<strong>从中国采购的量较大</strong>，建议关注。')" class="content"></span>
                  </div>
                </el-form-item>
                <el-form-item>
                  <el-button v-if="judgeWeb" type="primary" @click="buttontmat2('ruleForm2')" class="buttont">{{$t('dashboardCont.sureNext')}}</el-button>
                  <el-button v-if="!judgeWeb" type="primary" class="buttont" @click="buttontmat2('ruleForm2')">{{$t('sure')}}</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
           <div v-if="active==3">
            <div class="toutxt">
             {{$t('dashboardCont.useWeChat')}}
            </div>
            <div class="toutxt1">{{$t('dashboardCont.useWeChatOver')}}</div>
            <div>
               <div>
                  <iframe
                     class="imgurl" 
                      id="wx_qrcode"
                      width="320px"
                      height="290px"
                      scrolling="no"
                      :src="iframeUrl"
                      frameborder="0">
                  </iframe>  
               </div>
               <div class="fsapmt">
                   <span> <el-button type="primary" @click="buttontmat3()" class="buttont">{{$t('dashboardCont.scanCode')}}</el-button></span>
                   <span class="tlidhcu" @click="clicktetuli()">{{$t('dashboardCont.skip')}}>></span>
               </div>
            </div>
          </div>
      </el-dialog>
     </div>
     <!-- HS编码弹窗 -->
     <!-- <el-dialog :visible.sync="hsCodeVisible" :title="$i18.language('HS编码')">
      <div class="hscode-data">
        <el-input size="mini" v-model="filterText" :placeholder="$t('productDetail.pleaseEnterkeyWord')" @keyup.enter.native="getHsCodeDatated" >
          <i slot="suffix" class="el-input__icon el-icon-search"  @click="getHsCodeDatated"></i>
        </el-input>
        <div class="shotree">
          <el-tree class="filter-tree" :data="hsCodeData" @check="checkTree" :default-checked-keys="defaultHsCodeKeys"  :default-expanded-keys="defaultExpandedHsCodeKeys" show-checkbox ref="tree" node-key="id" :filter-node-method="filterNode"  v-loading="loadingTree">
            <span class="custom-tree-node" slot-scope="{ node }">
              <span v-if="!filterText">{{ node.label }}</span>
              <span v-if="filterText" v-html="node.label.replace(new RegExp(filterText,'g'),`<font>${filterText}</font>`)" />
            </span>
        </el-tree>
        </div>
       
        <div class="btn-group">
          <el-button size="small" class="sub-confirm-btn" @click="hsCodeVisible = false">{{$t('cancel')}}</el-button>
          <el-button size="small" class="confirm-btn" @click="confirmHsCode">{{$t('sure')}}</el-button>
        </div>
      </div>
    </el-dialog> -->
    <!-- 行业分类弹窗 -->
    <el-dialog :visible.sync="industryVisible" :title="$i18.language('选择行业')">
      <div class="hscode-data">
        <el-input size="mini" v-model="filterIndustryText" :placeholder="$t('productDetail.pleaseEnterkeyWord')" @keyup.enter.native="getIndustryDatated" >
          <i slot="suffix" class="el-input__icon el-icon-search"  @click="getIndustryDatated"></i>
        </el-input>
        <div class="shotree">
          <el-tree class="filter-tree" :data="industryData" @check="checkIndustryTree" :default-checked-keys="defaultIndustryKeys"  :default-expanded-keys="defaultExpandedIndustryKeys" :props="defaultProps" show-checkbox ref="industryTree" node-key="id" :filter-node-method="filterIndustryNode"  v-loading="loadingIndustryTree">
            <span class="custom-tree-node" slot-scope="{ node }">
              <span v-if="!filterIndustryText">{{ node.label }}</span>
              <span v-if="filterIndustryText" v-html="node.label.replace(new RegExp(filterIndustryText,'g'),`<font>${filterIndustryText}</font>`)" />
            </span>
        </el-tree>
        </div>
        <div class="btn-group">
          <el-button size="small" class="sub-confirm-btn" @click="industryVisible = false">{{$t('cancel')}}</el-button>
          <el-button size="small" class="confirm-btn" @click="confirmIndustry">{{$t('sure')}}</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 选择国家 -->
    <country-select ref="countrySelect" @changeCountryF="changeCountryF"></country-select>
    <hsCodeDialog ref="hsCodeDialog-0" :codeCheckLength="4" :submitCodeLimit="5" @confirmHsCode="confirmHsCode"></hsCodeDialog>
  </div>
</template>

<script>
import customSelect from '@/views/intelligence/components/customSelect.vue'
import CountrySelect from '@/components/countrySelect.vue'
import MultiInputTag from '@/views/Trade/components/TradeResults/MultiInputTag'
import productAndHs from '@/views/intelligence/components/productAndHs.vue'
import hsCodeDialog from '@/views/intelligence/components/hsCodeDialog'
export default {
  components: {
    customSelect,
    CountrySelect,
    MultiInputTag,
    productAndHs,
    hsCodeDialog
  },
  computed: {
    userInfo() {
      return localStorage.getItem('set_account_info') ? JSON.parse(localStorage.getItem('set_account_info')) : this.$store.getters.accountInfo
    },
    // 判断产品
    judgeWeb() {
      return ['DF', 'EC'].includes(this.$util.judgeOrigin())
    },
  },
  watch: {
    userInfo: {
      handler(val, oldVal) {
        if(val) {
          this.delayData();
        }
      },
      deep: true,
      immediate: true
    }
  },
  data () {
    var checkAge = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('原密码不能为空'));
        }else {
          callback();
        }
      };
    var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.ruleForm.checkPass !== '') {
            this.$refs.ruleForm.validateField('checkPass');
          }
          callback(); 
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm.pass) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      var validatePatext = (rule, value, callback) => {
        if(value.length>10){
          callback(new Error(this.$i18.language('请输入最多10组关键词')))
        }else if(value.length==0){
          callback(new Error(this.$t('message.rules.enterKeyword')))
        } else if(value.find(item => /[\u4E00-\u9FA5]/g.test(item))) {
          callback(new Error(this.$i18.language('请输入英语关键词')))
        }else {
          callback();
        }
   	}
      var validateHS = (rule, value, callback) => {
        console.log('ewoo');
        if(value.length>10){
          callback(new Error(this.$i18.language('请输入最多10组编码')))
        } else if (value.find(item => !(/^\d{4,10}$/.test(item)))) {
          callback(new Error(this.$i18.language('编码只能是4~10位纯数字编码')))
        }else {
          callback();
        }
   	}
      var validateIndustry = (rule, value, callback) => {
        console.log('ewoo');
        if(value.length>10){
          callback(new Error(this.$i18.language('请选择最多10个行业')))
        } else {
          callback();
        }
   	}
    return {
      defaultHsForm: () =>{
        return {key: [], hscodes: [], value: ""}
      },
      aiGenerateData: {
        industry: [],
        country: [],
        showIndustryReason: false,
        showCountryReason: false,
      },
      country_loading: false,
      industry_loading: false,
      isEN: localStorage.getItem("language")=='en'?true:false,
     Passwordmodification:false,
      active:2,
      ruleForm:{
          pass:"",
          checkPass:"",
          oldPassword:"",
      },
      ruleForm2:{
          country:[],//国家list(value, lable)
          countryId:[],//国家id
          hscodes_user:[],//HS编码
          belonging_to_industrys:[],//所属行业
          belonging_to_industrysIds:[],//所属行业id
          interestedProducts: [{key: [], value: "", hscodes: []}], // 新的关键词结构
          opened: false,
      },
      checkedHscodeItem: null, // 选中的设定推荐条件
      countrytdata:[],
      iframeUrl:"",
      countryVisible:false,
      tempParams: {
        countryId: null,
        productDescriptionType: 1,
        hsCodeType: 1,
        productDescription:"",
        hsCode:"",
      },
      countryData: [],
      allCountryData:[],
      rulest: {
          pass: [
            { validator: validatePass, trigger: 'blur' }
          ],
          checkPass: [
            { validator: validatePass2, trigger: 'blur' }
          ],
          oldPassword: [
            { validator: checkAge, trigger: 'blur' }
          ],
        },
      rulest2: {
          hscodes_user: [
             { validator: validateHS, trigger: ['blur','change'] }
          ],
          belonging_to_industrys: [
             { validator: validateIndustry, trigger: ['blur','change'] }
          ],
        },
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        hsCodeOptions:[],//hsCode编码选项
        industryOptions:[],//所属行业编码选项
        props: { multiple: true },
        hsCodeValue:[],//hscode值
        industryValue:[],//所属行业编码值
        hsCodeVisible:false,//hs编码数据弹窗
        filterText:'',
        hsCodeData: [],
        hsCodeParams: {
        countryId: 0,
        isEnLanguage: localStorage.getItem("language")=='en'?true:false,
        keyword: '',
        },
        defaultHsCodeKeys: [],
        selectParentItems: [], // 展示的所有选中的最高级节点树
        hsShowCodes: ['0'], // 选中的最高级节点id
        loadingTree: false ,// 加载行业HS的loading
        chart1Params:{
          hsCode: [],
          hsCode1:[]
        },
        industryVisible:false,//行业分类弹窗
        filterIndustryText:'',
        //行业分类参数
        industryParams:{
          countryId: 43,
          isEnLanguage: localStorage.getItem("language")=='en'?true:false,
          keyword: '',
          sourceType: ''  
        },
        industryData:[],//行业分类集合
        selectParentIndustryItems: [], // 展示的所有选中的最高级节点树
        defaultIndustryKeys:[],
        loadingIndustryTree:false,//加载行业类loading
        indsutryShowCodes:['0'],
         industryCodes:[],
         indsutryShowCodeLable:[], //行业分类中文名称
         contactHsCodes:[],//处理过的行业分类数组
         childrenLength:1, //国家总和的长度
         defaultExpandedHsCodeKeys:[],//hs编码需要展开的节点
         defaultExpandedIndustryKeys:[],//行业分类需要展开的节点
         idLastList:[],//获取第一大类的最后一位节点
         isClickJump:false,//是否点击跳转按钮
      }
      
  },
  created () {
    // this.delayData();
  },
  mounted () {
    if(this.$util.isLogin() && this.industryData&& this.industryData.length==0){
      this.getIndustryCategory()
    }
  },
  methods: {
    // 国家id标准化为[{label,value}]
    formatCountryArray(countryIDs) {
      if (countryIDs.length == 1 && countryIDs[0] == 0) return [{label: this.$t('homes.allCountry'), value : 0}]
      return countryIDs.flatMap(value => 
        this.allCountryData.flatMap(country => 
          country.children.filter(child => child.value === value)
        )
      );
    },
    processArrays(A, B, C) {
      const setB = new Set(B);
      const setC = new Set(C);
      const seen = new Set();
      const result = [];
      // 步骤 1: 比较 A 和 B，保留 A 中也在 B 中出现的项
      const filteredA = A.filter(e => setB.has(e));
      filteredA.forEach(e => seen.add(e));
      result.push(...filteredA);
      // 删除AI生成的推荐国家
      for (let i = this.aiGenerateData.country.length - 1; i >= 0; i--) {
        if (!filteredA.includes(this.aiGenerateData.country[i].value)) {
          this.aiGenerateData.country.splice(i, 1);
        }
      }
      if (this.aiGenerateData.country.length == 0) {
        this.aiGenerateData.showCountryReason = false
      }
      // 步骤 2: 比较 B 和 C，找到重复项
      const commonBC = B.filter(e => setC.has(e));
      commonBC.forEach(e => {
        if (!seen.has(e)) {
          result.push(e);
          seen.add(e);
        }
      });
      // 步骤 3: 找出 B 中不在 C 中出现的项
      const uniqueB = B.filter(e => !setC.has(e));
      uniqueB.forEach(e => {
        if (!seen.has(e)) {
          result.push(e);
          seen.add(e);
        }
      });
      return result;
    },
    filterArray(arrA, arrB) {
      let filterArr = arrA.filter(text => {
        return !arrA.includes(arrB.find(e => e === text));
      });
      return filterArr
    },
    filterHasParents(A, B) {
      const result = [];
      const buildIdMapping = (nodes) => {
        return nodes.flatMap(node => {
          const map = [[node.id, node]];
          return node.children ? [...map, ...buildIdMapping(node.children)] : map;
        });
      }
      const findParents = (id) => {
        const parents = [];
        const idMapping = Object.fromEntries(
          this.industryData.flatMap(node => {
            const map = [[node.id, node]];
            return node.children ? [...map, ...buildIdMapping(node.children)] : map;
          })
        );
        while (id != 0) {
          const node = idMapping[id];
          if (!node) break;
          if (node.parentId != 0) { // 只在 parentId 不为 0 时才添加
              parents.push(node.parentId);
          }
          id = node.parentId; // 更新 id 为父级 ID
        }
        return parents;
      }
      A.forEach(aId => {
        const parents = findParents(aId);
        const matchedParents = parents.filter(parentId => B.includes(parentId));
        
        if (matchedParents.length == 0) {
          result.push(aId)
        }
      });
      result.push(...B)
      return result;
    },
    mergeArray(arrA, arrB, valueType='value') {
      // 过滤出在 arrA 中但不在 arrB 中的项
      let itemsNotInB = arrA.filter(itemA => !arrB.some(itemB => itemB[valueType] == itemA[valueType]));
      return [...arrB, ...itemsNotInB]; // 合并 arrB 和不在 arrB 中的 arrA 项
    },
    aiGenerate(type) {
      this[type+"_loading"] = true
      if (type == 'industry') {
        const params = {
          queries: this.ruleForm2.interestedProducts.filter(e=>e.value).map(e=>e.value),
          return_k: 3,
          top_k: 3 
        }
        if (params.queries.length == 0) {
          this[type+"_loading"] = false
          return this.$message.warning(this.$i18.language("请输入产品关键词"))
        }
        // 删除旧的AI生成项
        this.contactHsCodes = this.contactHsCodes.filter(e=>e.tagClass!="isAIGenerate")
        let lang = localStorage.getItem("language") || "zh"
        this.$api.ai.getAIindclass(params).then(result => {
          let res = { data: result.map(el => ({ label: el[`name_${lang}`], val: Number(el.id), tagClass: "isAIGenerate" })) }
          if (res.data.length > 0) {
            this.aiGenerateData.industry = res.data
            this.aiGenerateData.showIndustryReason = true
            
            let filterIndustryValue = this.filterHasParents(this.ruleForm2.belonging_to_industrysIds.map(Number), res.data.map(e=>Number(e.val)))
            let mergeArray = this.mergeArray(this.contactHsCodes, res.data, "val")
            this.contactHsCodes = mergeArray.filter(el=>filterIndustryValue.includes(el.val))
          }
          this[type+"_loading"] = false
        })
      }
      if (type == 'country') {
        const params = {
          hscodes: this.ruleForm2.interestedProducts.map(e=>e.hscodes).flat().filter(e=>e)
        }
        if (params.hscodes.length == 0) {
          this[type+"_loading"] = false
          return this.$message.warning(this.$i18.language("请输入HS编码"))
        }
        // 删除旧的AI生成项
        this.ruleForm2.country = this.ruleForm2.country.filter(e=>e.tagClass!="isAIGenerate")
        this.ruleForm2.countryId = this.ruleForm2.country.map(e=>e.value)
        this.$api.ai.recommendCountryByHs(params).then((res) => {
          if (res.data.length > 0) {
            res.data.forEach(el => {
              el.tagClass = "isAIGenerate"
            })
            this.aiGenerateData.country = res.data
            this.aiGenerateData.showCountryReason = true
            // 全部国家直接替换
            if (this.ruleForm2.country.length == 0 || this.ruleForm2.country[0].value == 0) {
              this.ruleForm2.country = res.data
            } else {
              this.ruleForm2.country = this.mergeArray(this.ruleForm2.country, res.data)
            }
            this.ruleForm2.countryId = this.ruleForm2.country.map(e=>e.value)
          }
          this[type+"_loading"] = false
        })
      }
    },
    // 清除hsCode
    handleRemove(val) {
      // contactHsCodes中删除当前项
      this.contactHsCodes.splice(this.contactHsCodes.findIndex(e=>e.val==val.val), 1)
      // 从本次AI生成的行业了列表中删除当前项
      const ai_industry = this.aiGenerateData.industry
      ai_industry.forEach((el, index)=>{
        if (el.val == val.val) {
          this.aiGenerateData.industry.splice(index, 1)
          this.aiGenerateData.showIndustryReason = this.aiGenerateData.industry.length > 0 ? true : false
        }
      })
    },
    handleRemoveCountry(item){
      // countryId和country中删除当前项
      this.ruleForm2.countryId = this.ruleForm2.country.filter(e=>e.value!=item.value).map((e) => e.value)
      this.ruleForm2.country.splice(this.ruleForm2.country.findIndex(e=>e.value==item.value), 1)
      // 从本次AI生成的国家列表中删除当前项
      const ai_countrylist = this.aiGenerateData.country
      ai_countrylist.forEach((el, index)=>{
        if (el.value == item.value) {
          this.aiGenerateData.country.splice(index, 1)
        }
      })
      this.aiGenerateData.showCountryReason = this.aiGenerateData.country.length > 0 ? true : false
    },
    xunxioanggj(){
      if(!this.ruleForm2.opened) return
      let countryId = 0
      if(this.ruleForm2.countryId && this.ruleForm2.countryId.length) {
        countryId = this.ruleForm2.countryId.length>1?0:this.ruleForm2.countryId[0]
      }
      let data = {
        countryIds: this.ruleForm2.countryId?this.ruleForm2.countryId:[],
        countryId
      }
      // 如果是空则不勾选全部国家
      if (this.ruleForm2.country.length == 0) {
        data = {countryId: "", countryIds: []}
      }
      //需要把国家对应的id处理
      this.$refs.countrySelect.openCountrySelect(data)
    },
    changeDataType() {
      this.$api.public.getCountryOptions().then(res => {
        res.data.forEach(item => {
          this.childrenLength+=item.children.length
             item.children.forEach(itemt => {
               itemt.checkout=false;
             });
        });
        this.allCountryData = this.$refs.countrySelect.countryData = [
          {
            label: this.$t('homes.global'),
            value: 0,
            children: [
              {
                checkout:false,
                label: this.$t('homes.allCountry'),
                value: 0,
                ie: [1, 2],
                isOpen:true,
              }
            ]
          },
          ...res.data
        ]

        })
       
    },
    changeCountry(itemd) {
      itemd.checkout = !itemd.checkout
      if(itemd.checkout==false){
        let index=this.countrytdata.findIndex(item =>item.value==itemd.value) 
        if(index>-1){
          this.countrytdata.splice(index, 1)
        }
      }else{
        let index=this.countrytdata.findIndex(item =>item.value==itemd.value)  //查找存放的数组是否有当前国家value
        if(index>-1){ //如果有的话先截
          this.countrytdata.splice(index, 1)
        }
        if(itemd.value==0){//判断当前选中的是否是全部国家
          this.countrytdata=[]
          this.countryData.forEach((item) => {
            item.children.forEach((itemt) => {
              if(itemt.value!==0){ 
                itemt.checkout = false
              }
            })
          })
        }else{ 
          let index=this.countrytdata.findIndex((item)=>item.value==0)
          if(index>-1){
            this.countrytdata.splice(index,1)
            this.countryData.forEach((item) => {
              item.children.forEach((itemt) => {
              if(itemt.value==0){
                itemt.checkout = false
              }
            })
            })
          }
        }
        this.countrytdata.push(itemd)
        if(this.countrytdata.length==this.childrenLength){
          this.countryData.forEach((item) => {
              item.children.forEach((itemt) => {
              itemt.checkout = false
              if(itemt.value==0){
                itemt.checkout = true
              }
              this.countrytdata = []
              this.countrytdata.push({
                checkout:true,
                label: this.$t('homes.allCountry'),
                value: 0,
                ie: [1, 2],
                isOpen:true,
              })
            })
            })
        }
      }
     
    },
    cancelCountry(){
     this.countryVisible=false;
    },
    changeCountryF(item) {
      // 优先展示AI生成的国家
      let countryIdArray = this.processArrays(this.aiGenerateData.country.map(el=>el.value), item.patteguid, this.ruleForm2.countryId)
      this.ruleForm2.countryId = countryIdArray
      this.ruleForm2.country = this.formatCountryArray(countryIdArray).map(e => ({
        ...e, tagClass: this.aiGenerateData.country.find(el => el.value === e.value)?.tagClass || ''
      }));
    },
      // 步骤条
    buttontmat(ruleForm){
       this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            const params = {
                oldPassword:this.ruleForm.oldPassword,
                newPassword:this.ruleForm.checkPass,
            };
            this.$api.dashboard.changePassword(params).then(res => {
              if(res.code==200){
                this.$message({ message: this.$t('message.success.passwordModifiedSuccess'),type: 'success'});
                this.active++;
              }
              });

          } else {
            return false;
          }
          this.getHsCodeData()
          this.getIndustryCategory()

        });
      // this.active++;
    },
    buttontmat2(ruleForm2){
      let validFlag = true
      this.$refs[ruleForm2].validate((valid) => {
        validFlag = valid
      })
      let {opened, interestedProducts} = this.ruleForm2
      if(opened) {
        validFlag = !this.$refs.productAndHs.checkFields()
        if(!validFlag) {
          return this.$message.warning(this.$i18.language("每组条件中，关键词或编码栏目这2项，至少1个栏目有值，且HS编码不超过5个"))
        }
      }
      if(validFlag) {
        const params = {
          opened,
          product: 'gt6',
          interestedProducts,
          interestedCountryIds:this.ruleForm2.countryId,
          interestedIndustrys: this.contactHsCodes.map(e=>e.val),
        }
        
        if (opened && interestedProducts.length > 5 ) {
          return this.$message.warning(this.$i18.language("最多可设置5组条件!"))
        }
        Promise.all([this.$api.user.saveAiSetting(params)]).then((res) => {
          if(res[0].code==200){
            this.getUserAccount()
            this.getResetUserCache()
            if(this.judgeWeb) {
              const params = {
              // returnUrl:"https://demo.topease.net/gt5api/dashboard",
              returnUrl:this.$util.getCurrentWebSiteByProduct()+`/dashboard`,
              };
                // 微信二维码
              this.$api.user.getUrl(params).then(res => {
                this.iframeUrl = res.data;
                this.active++;
              });
            }
            
            }
        }).catch((err)=>{
        })
      }
    },
    buttontmat3(){
        const params = {
            returnUrl:this.$util.getCurrentWebSiteByProduct()+`/dashboard`,
          // returnUrl:"https://demo.topease.net/gt5api/dashboard",
        };
        // 微信二维码
        this.$api.user.getUrl(params).then(res => {
              this.iframeUrl = res.data;
          });
        },
        //刷新账户中心缓存
        getResetUserCache(){
          this.$api.user.getResetUserCache().then(res => {
           if(res.code==200){
              localStorage.setItem('pass_change', JSON.stringify(1))
             console.log('更新成功')
           }
          });
        },
    clicktetuli(){
      this.Passwordmodification=false;
      this.isClickJump= true
      this.getUserInfode();
      if (this.$route.path == "/dashboard") {
        window.location.reload()
      }
    },
    //延迟加载
    delayData(){
     let getUserInfo = setTimeout(item=>{
        if (localStorage.getItem('pass_change')===null){
          console.log("**...**");
          if (this.$util.isLogin()){
            this.getUserInfode()
            this.$nextTick(()=>{
              this.$refs[`hsCodeDialog-0`].getHsCodeData(0)
            })
          }
        }else{
          clearTimeout(getUserInfo);
          this.Passwordmodification=false;
        }
      },2000)
    },
    // 重新获取用户信息
    getUserAccount(){
      this.$api.dashboard.getUserInfo().then(res => {
        if(res.code==200) {
          this.$store.commit('set_account_info', res.data)
          window.localStorage.setItem("set_account_info", JSON.stringify(res.data));
          if(!this.judgeWeb) {
            this.clicktetuli()
          }
        }
      })
    },
    getUserInfode(){
      let userInfo = localStorage.getItem('set_account_info') ? JSON.parse(localStorage.getItem('set_account_info')) : this.$store.getters.accountInfo
      let {gt6_products_interested, is_oalogin} = userInfo
            if((!gt6_products_interested || !gt6_products_interested.length)&&(is_oalogin === false)){
        // 1为已经改过密码,0为需要更改密码
        this.Passwordmodification=true;
        this.changeDataType();
      }else {
        localStorage.setItem('pass_change', JSON.stringify(1))
        this.Passwordmodification=false;
      }    
    },
    //HS编码弹窗
    showHsCodeSelect(num, data) {
      this.checkedHscodeItem = data
      this.$nextTick(()=>{
        let getData = this.$store.getters.hsCodeData
        this.$refs[`hsCodeDialog-0`].hsCodeData= getData
        // 修改完成后清除掉hs和行业编码的筛选内容
        this.$refs[`hsCodeDialog-0`].filterText=''
        let hsCodes = data.hscodes
        //处理后端返回的id及名称拼接处理 
        this.$refs[`hsCodeDialog-0`].open(hsCodes,0)
      })
    },
    showIndustrySelect() {
      this.industryVisible = true
      if(this.industryData&& this.industryData.length===0){
        this.getIndustryCategory()
      }
      this.defaultExpandedIndustryKeys = []
      this.$nextTick(()=>{
      if (this.$refs.industryTree) {
        this.defaultIndustryKeys = []
        this.selectParentIndustryItems= []
        this.defaultExpandedIndustryKeys = this.contactHsCodes.map(e=>e.val)
        this.$refs.industryTree.setCheckedKeys(this.contactHsCodes.map(e=>e.val))
        this.$refs.industryTree.getCheckedNodes()
        this.$refs.industryTree.getCheckedNodes().forEach((item) => this.checkIndustryTree(item))
      } else {
        this.defaultIndustryKeys = []
      }
    })
    },
    getHsCodeDatated(){
        let val=this.filterText.trim();
        if(val&&val.length<2) {
          this.$message.warning(this.$i18.language('输入内容至少2位'))
          return
        }
         this.$refs.tree.filter(val);  
    },
    //过滤行业分类
    getIndustryDatated(){
      let val=this.filterIndustryText;
      this.$refs.industryTree.filter(val);  
    },
    filterNode(value, hsCodeData) {
      if (!value) return true
      if(/^[0-9]*$/.test(value)) {
        return hsCodeData.label.indexOf(value) === 0
      } else {
        return hsCodeData.label.indexOf(value) !== -1
      }
    },
      filterIndustryNode(value, industryData) {
        if (!value) return true;
        return industryData.label.indexOf(value) !== -1;
      },
    getHsCodeData() {
      this.loadingTree = true
      this.$api.public.getHsCodeData(this.hsCodeParams).then(res => {
        this.isDisabled(res.data)
        this.hsCodeData = [
          ...res.data
        ]
        this.loadingTree = false
      })
    },
    //是否禁用（小于八位禁用）
    isDisabled(data){
       data.forEach((item)=>{
        if(!(1*item.id) || item.id.length<4){
           item.disabled=true
           if(item.children&&item.children.length>0){
             this.isDisabled(item.children)
           }
          }
         return data
       })
    },
    FilterChildren(hsCodeData){
      if(hsCodeData.length>0){
      let firstNode = hsCodeData[0]
      if(firstNode.children&&firstNode.children.length>0){
        firstNode.children.forEach((item,index)=>{
          if(index==0){
            if(item.children&&item.children.length>0){
              this.FilterChildren(item.children)
            }else{
              this.idLastList = []
              this.idLastList.push(item.id)
            }
          }
          
        })
      }
    }
      return this.idLastList
    },
      // 选中树形节点
      checkTree(data) {
      let thisNode = this.$refs.tree.getNode(data.id) // 获取当前节点
      let parentNode = thisNode.parent  // 获取父级节点
      let shiftArr = [].concat(this.selectParentItems) // concat不改变原数组
      let result = [] // 最终保留展示节点
      if(parentNode.checked) {
        while(parentNode.checked) {
          let currentChildKeys = []
          let thisChildNodeKeys = []
          // 如果父级选中,保留父级节点，父级所有子集节点从数组中删除
          currentChildKeys = parentNode.childNodes.map(item=>item.data.id)
          thisChildNodeKeys = thisNode.childNodes.map(item=>item.data.id)
          let childKeys = [...currentChildKeys, ...thisChildNodeKeys]
          result = shiftArr.filter(node => !childKeys.includes(node.data.id)) // 删除选中父级的所有子集元素
          result.push(parentNode) // 先将当前选中父级塞入结果中
          shiftArr = result
          thisNode = parentNode
          parentNode = parentNode.parent // 递归向上查找父级
        }
        this.selectParentItems = shiftArr
      } else {
        if(thisNode.checked) {
          // 数组中去掉子集元素
          let currentChildKeys = []
          // 如果父级选中,保留父级节点，父级所有子集节点从数组中删除
          let children = this.flatten(thisNode.childNodes)
          currentChildKeys = children.map(item=>item.data.id)
          result = shiftArr.filter(node => !currentChildKeys.includes(node.data.id)) // 删除选中父级的所有子集元素
          result.push(thisNode) // 父级未选中，且当前点击节点选中
          this.selectParentItems = result
        } else {
          // 父级未选中，且当前节点未选中，删除当前节点
          let index = this.selectParentItems.findIndex(item=>item.data.id == thisNode.data.id)
          let end = this.selectParentItems.map((item) => item.data.id).lastIndexOf(thisNode.data.id)
          if(index >= 0) this.selectParentItems.splice(index, end + 1)
          let brotherNodes = []
          while(parentNode.parent) {
            let index = this.selectParentItems.findIndex(i=>i.data.id == parentNode.data.id)
            let end = this.selectParentItems.map((item) => item.data.id).lastIndexOf(parentNode.data.id)
            if(index >= 0 ) {
              this.selectParentItems.splice(index, end + 1)
            }
            brotherNodes = brotherNodes.concat(parentNode.childNodes.filter(node=>node.data.id!==thisNode.data.id&&node.checked))
            thisNode = parentNode
            parentNode = parentNode.parent
          }
          // 如果父级节点历史选中过，则保留兄弟节点
          this.selectParentItems = this.$util.unique([...brotherNodes, ...this.selectParentItems])
        }
      }
    },
    checkIndustryTree(data){
      let thisNode = this.$refs.industryTree.getNode(data.id) // 获取当前节点
      let parentNode = thisNode.parent  // 获取父级节点
      let shiftArr = [].concat(this.selectParentIndustryItems) // concat不改变原数组
      let result = [] // 最终保留展示节点
      if(parentNode.checked) {
        while(parentNode.checked) {
          let currentChildKeys = []
          let thisChildNodeKeys = []
          // 如果父级选中,保留父级节点，父级所有子集节点从数组中删除
          currentChildKeys = parentNode.childNodes.map(item=>item.data.id)
          thisChildNodeKeys = thisNode.childNodes.map(item=>item.data.id)
          let childKeys = [...currentChildKeys, ...thisChildNodeKeys]
          result = shiftArr.filter(node => !childKeys.includes(node.data.id)) // 删除选中父级的所有子集元素
          result.push(parentNode) // 先将当前选中父级塞入结果中
          shiftArr = result
          thisNode = parentNode
          parentNode = parentNode.parent // 递归向上查找父级
        }
        this.selectParentIndustryItems = shiftArr
      } else {
        if(thisNode.checked) {
          // 数组中去掉子集元素
          let currentChildKeys = []
          // 如果父级选中,保留父级节点，父级所有子集节点从数组中删除
          let children = this.flatten(thisNode.childNodes)
          currentChildKeys = children.map(item=>item.data.id)
          result = shiftArr.filter(node => !currentChildKeys.includes(node.data.id)) // 删除选中父级的所有子集元素
          result.push(thisNode) // 父级未选中，且当前点击节点选中
          this.selectParentIndustryItems = result
        } else {
          // 父级未选中，且当前节点未选中，删除当前节点
          let index = this.selectParentIndustryItems.findIndex(item=>item.data.id == thisNode.data.id)
          if(index >= 0) this.selectParentIndustryItems.splice(index, 1)
          let brotherNodes = []
          while(parentNode.parent) {
            let index = this.selectParentIndustryItems.findIndex(i=>i.data.id == parentNode.data.id)
            if(index >= 0 ) {
              this.selectParentIndustryItems.splice(index, 1)
            }
            brotherNodes = brotherNodes.concat(parentNode.childNodes.filter(node=>node.data.id!==thisNode.data.id&&node.checked))
            thisNode = parentNode
            parentNode = parentNode.parent
          }
          // 如果父级节点历史选中过，则保留兄弟节点
          this.selectParentIndustryItems = this.$util.unique([...brotherNodes, ...this.selectParentIndustryItems])
        }
      }
    },
    // 递归将选中的当前对象变为一维数组，获取所有子元素id
    flatten(arr) {
      return [].concat(...arr.map(item => {
        if (item.childNodes) {
          let arr = [].concat(item, ...this.flatten(item.childNodes));
          return arr;
        }
        return [].concat(item);
      }
      ));
    },
    // 处理一二级数据
    handleDeep(data, hsCodesSend) {
      let item = data.data || data
      if(!(1*item.id) || item.id.length < 1*4) {
        item.children.map(v=>this.handleDeep(v, hsCodesSend))
      } else {
        hsCodesSend.push(item.id)
      }
      return hsCodesSend
    },
    confirmHsCode( hsCodes, showHsCodes,hsShowCodeLable,contactHsCodes, selectParentItems) {
      let hsCodesSend = []
      selectParentItems.forEach(item=>{
        hsCodesSend = this.handleDeep(item, hsCodesSend)
      })
      hsCodesSend = Array.from(new Set(hsCodesSend))
      //  let newHsCodes = hsCodes.filter((item) => item.length > 5)
      this.$set(this.checkedHscodeItem, 'hscodes', hsCodesSend)
    },
    confirmIndustry(){
      let indsutryShowCodes = this.selectParentIndustryItems.map(item=>item.data.id)
      this.indsutryShowCodes = Array.from(new Set(indsutryShowCodes))
      let indsutryShowCodeLable =this.selectParentIndustryItems.map(item=>item.data.label)  //获取节点对应的中文名称
      this.indsutryShowCodeLable = Array.from(new Set(indsutryShowCodeLable))
      const industryCodes = this.$refs.industryTree.getCheckedNodes().map(item => {
        return item.id
      })
      //将选中的节点拼接成[{label:'',id:0}]
      if(this.indsutryShowCodes.length==this.indsutryShowCodeLable.length){
        let contactHsCodes = this.changeContactHscodes(this.indsutryShowCodes, this.indsutryShowCodeLable);
        let ai_industry = this.aiGenerateData.industry.map(e => e.val);
        let industryTemp = []; // 用来存放AI生成的项
        let otherTemp = []; // 用来存放非AI生成的项
        contactHsCodes.forEach(el => {
          if (ai_industry.includes(el.val)) {
            el.tagClass = "isAIGenerate";
            industryTemp.push(el); // 已选择的ai industry加入industryTemp
          } else {
            otherTemp.push(el); // 其他项排后面加入otherTemp
          }
        });
        this.aiGenerateData.industry = industryTemp // 过滤删除掉未勾选的ai industry
        this.aiGenerateData.showIndustryReason = industryTemp.length > 0 ? true : false
        industryTemp = [...industryTemp, ...otherTemp];
        this.contactHsCodes = industryTemp
      }
      this.ruleForm2.belonging_to_industrysIds = this.indsutryShowCodes
      this.ruleForm2.belonging_to_industrys = this.indsutryShowCodeLable
      if(!industryCodes.length) { 
        this.contactHsCodes = []
        this.industryCodes = []
        this.ruleForm2.belonging_to_industrys = []
        this.ruleForm2.belonging_to_industrysIds = []
        this.defaultExpandedIndustryKeys = []
        this.aiGenerateData.showIndustryReason = false
      }
      this.defaultExpandedIndustryKeys = []
      this.industryVisible = false
    },
    changeContactHscodes(idList,lableList){
      let contactHsCodes = []
      idList.forEach((item,index)=> {
        contactHsCodes.push({
          val:item,
          label:lableList[index]
        })
      })
      return contactHsCodes
    },
    // hs编码
    loseBlur(val) {
      this.$refs.ruleForm2.validateField('hscodes_user')
    },
    //移除标签时触发的选项阻止弹框展示
    removeTag(val,isType){
      if(isType==1){
        this.hsCodeVisible = false
      }else{
        let getValue =  this.contactHsCodes.find((item)=>item.label==val).val
       let index = this.ruleForm2.belonging_to_industrysIds.map(String).indexOf(String(getValue))
      if(index>-1){
        this.ruleForm2.belonging_to_industrysIds.splice(index,1)
        this.contactHsCodes.splice(index,1)
      } 
      }
    
    },
    //获取行业分类编码
    getIndustryCategory() {
      if (this.$store.getters.industryData && this.$store.getters.industryData.length > 0) {
        this.industryData = this.$store.getters.industryData
      }else {
        this.loadingIndustryTree = true
        this.$api.public.getCompanyIndustryCateGory().then((res) => {
          this.isDisabled(res.data)
          this.industryData = res.data
          this.loadingIndustryTree =false
        })
      }
    },
    //触发主要查询产品关键词
    inputEnterChange(val){
    },
  }
}
</script>

<style lang="scss" scoped>

.dialogmimaxg{
  /deep/.el-dialog{
    margin-top: 12vh !important;
  }
  /deep/.el-dialog .el-dialog__header{
      padding:10px 0;
      border-bottom:0;
  }
}
.is-disabled.form-item {
  cursor: not-allowed;
}
.form-item {
  /deep/ .el-select__tags {
    max-height: 74px;
    overflow-y: auto;
    max-width: 99% !important;
    &::-webkit-scrollbar {
      width: 5px; /* Chrome Safari */
      height: 5px;
    }
    &::-webkit-scrollbar-thumb {
      background: $--scrollbar-thumb-color; // 滑块颜色
      border-radius: 5px; // 滑块圆角
    }
    &::-webkit-scrollbar-thumb:hover {
      background: $--scrollbar-thumb-hover-color; // 鼠标移入滑块hover
    }
  }
  /deep/ .el-select {
    input {
      // padding: 0;
    }
    .el-input__suffix {
      display: none;
    }
  }
  /deep/ .is-disabled {
    cursor: not-allowed;
    pointer-events: none;
    .el-tag {
      background-color: #f4f4f5;
      color: #909399;
    }
    input {
      background-color: #f4f4f5;
    }
  }
  .el-input__suffix {
    display: none;
  }
}
.el-form-item {
  margin-bottom: 10px;
}
/deep/.el-form--label-top .el-form-item__label {
    float: none;
    display: inline-block;
    text-align: left;
    padding:0;
    }
.el-icon-arrow-up:before {
        content: '';
    };
.toutxt{
    margin:20px 0 10px;
    font-size: 14px;
    font-weight:600;
    color: #1A173B;
}
.dialogheig{
  height: 50vh;
  overflow: auto;
}
.toutxt1{
  margin:16px 0;
  font-weight: 400;
  font-style: normal;
  // font-size: 12px;
  line-height:18px;
  color: $--color-font-light;;
}
/deep/.el-form-item__label {
    // font-size: 12px;
    line-height: 30px;
   
}
/deep/.el-input--medium .el-input__inner {
    height: 36px;
    line-height: 36px;
    // font-size: 12px;
}
.buttont{
  width: 220px;
  display:block;
  margin:0 auto;
  background:#EA5519;
  border-color: #EA5519;
}
/deep/.el-button--primary:hover, .el-button--primary:focus {
    background: #EA5519;
    border-color: #EA5519;
    color: #fff;
}
.imgurl{
//  padding-left:9%;
 position: relative;
 left: 50%;
 transform: translateX(-50%);
}
.label {
  display: flex;
  justify-content: space-between;
}
.fsapmt{
  position: relative;
}
.tlidhcu{
 color:$--color-primary-6;
 font-size: 15px;
 cursor:pointer;
 position: absolute;
 right:0;
 top:13px;
}
.num-text{
  display:inline-block;
  height:22px;
  width:39px;
  background-color:red;
  background: #F8F8F8;
  line-height: 22px;
  margin-top: 5px;
  border-radius: 3px;
}
.hscode-data {
    .shotree {
      height: 50vh;
      overflow: auto;
      margin-top: 10px;
    }
    /deep/.filter-tree {
      .el-tree-node {
        .el-tree-node__content {
          height: auto;
          .el-tree-node__label {
            font-size: 12px;
            white-space: normal;
            padding: 5px 0;
            line-height: 18px;
            word-break: break-word;
          }
        }
      }
    }
    .btn-group {
      padding-top: 20px;
      text-align: right;
    }
  }
  .multiple-box,.input-enter{
   /deep/.el-icon-arrow-up:before{
    content: '' !important;
    }
    /deep/.el-select-dropdown,.el-select-dropdown__empty{
       display: none !important;
      }
/deep/.el-input__suffix{
        display: none !important;
      }
   /deep/.el-icon-arrow-up:before{
      content: '' !important;
      }
}
.ai_generate {
    cursor: pointer;
    background-image: -webkit-linear-gradient(left, #b856fc, #a56dfe, #977bfe);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    color: $--color-link;
    position: absolute;
    top: -28px;
    font-weight: 500;
    right: 0;
    z-index: 9;
  }
  /deep/ .el-skeleton, /deep/ .el-skeleton__item.el-skeleton__p.is-first {
    height: 28px;
    width: 100%;
  }
  /deep/ .isAIGenerate {
    border: 1px solid transparent;
    border-radius: 5px;
    background-clip: padding-box, border-box;
    background-origin: padding-box, border-box;
    background-image: linear-gradient(to right, #ffffff, #ffffff), linear-gradient(90deg, #8F41E9, #578AEF)
  }
  /deep/ .reason {
    .content {
      strong {
        position: relative;
        z-index: 1;
        display: inline-block;
        line-height: 16px;
        &::after {
          content: "";
          width: 100%;
          height: 3px;
          position: absolute;
          left: 0;
          bottom: 0px;
          z-index: -1;
          border: 1px solid transparent;
          border-radius: 10px;
          background-image: linear-gradient(to right, #FDB32F, #fff7e9ec);
        }
      }
    }
  }
.LaterTips {
  padding-bottom: 16px;
  display: block;
  color: $--color-theme;
}
</style>
<style lang="scss">
.input-enter-select-popper {
  display: none;
}
.demo-ruleFormty {
  .main_pro_tips {
    color: $--color-font-light;
  }
}
</style>
